import { render, staticRenderFns } from "./TaxPayerId.vue?vue&type=template&id=bc5895b4&scoped=true"
import script from "./TaxPayerId.vue?vue&type=script&lang=js"
export * from "./TaxPayerId.vue?vue&type=script&lang=js"
import style0 from "./TaxPayerId.vue?vue&type=style&index=0&id=bc5895b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5895b4",
  null
  
)

export default component.exports